import {
  TrainingCategoryBehaviorIcon,
  TrainingCategoryChoresIcon,
  TrainingCategoryFunIcon,
  TrainingCategoryGeneralIcon,
  TrainingCategoryWorkIcon,
} from '../wag-react/next-components/icons';

export enum TrainingCategory {
  Behavior = 'Behavior',
  Chores = 'Chores',
  Fun = 'Fun',
  General = 'General',
  Work = 'Work',
}

export const TrainingCategoryIconMap = {
  [TrainingCategory.Behavior]: TrainingCategoryBehaviorIcon,
  [TrainingCategory.Chores]: TrainingCategoryChoresIcon,
  [TrainingCategory.Fun]: TrainingCategoryFunIcon,
  [TrainingCategory.General]: TrainingCategoryGeneralIcon,
  [TrainingCategory.Work]: TrainingCategoryWorkIcon,
};
